import { render } from "./BookingGroupNameBadge.vue?vue&type=template&id=dfbc5c3c"
import script from "./BookingGroupNameBadge.vue?vue&type=script&lang=js"
export * from "./BookingGroupNameBadge.vue?vue&type=script&lang=js"

import "./BookingGroupNameBadge.vue?vue&type=style&index=0&id=dfbc5c3c&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__